module.exports = __webpack_public_path__ + "static/img/logo.ec3b524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/logo.png
// module id = Phjq
// module chunks = 5